var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": "담당자명"
    },
    model: {
      value: _vm.inputData.workerName,
      callback: function callback($$v) {
        _vm.$set(_vm.inputData, "workerName", $$v);
      },
      expression: "inputData.workerName"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": "직책"
    },
    model: {
      value: _vm.inputData.workerTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.inputData, "workerTitle", $$v);
      },
      expression: "inputData.workerTitle"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }